import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import Query from 'dashboard-services/api/Query'
import { DataLakeEnums } from 'dashboard-services/api/dataLake'
import { globalActions } from 'primary-components'

import { filesDatalakeActions } from 'actions/modules/datalake'
import getApiConfig from 'api/ApiConfig'
import { filesDatalakeQueries } from 'queries/modules/datalake'
import { myAccountSelectors } from 'selectors/modules/myAccount'

const WAREHOUSE_HYBRID_VALUES = ["hybrid", "hybrid_ts", "only"]
const WAREHOUSE_STATUS = "WAREHOUSE_STATUS"
export default (() => {
  const usePendingApprovalsCount = ({ groupName, enabled }) => {
    const dispatch = useDispatch(),
          [searchParams] = useSearchParams(),
          provider = searchParams.get('provider') || undefined,
          userName = myAccountSelectors.useFromSettingsState('userName'),
          isEnabled = !!enabled && !!userName,
          query = useMemo(() => dispatch(filesDatalakeActions.getApprovalsQuery({
            groupName, reviewer: userName, reviewStatus: DataLakeEnums.REVIEW_STATUS.OPEN
          })), [dispatch, groupName, userName]),
          getQueryBuilder = useCallback(() =>
            new Query.Builder(dispatch(getApiConfig()))
              .withFetching(false)
              .withHeader('Target', provider, true)
          , [dispatch, provider]),
          shouldBeLimited = useCallback(provider => dispatch(globalActions.shouldTheApiBeLimited(provider)), [dispatch]),
          { data, isError } = filesDatalakeQueries.useSearchFilesCount({
            query, provider, getQueryBuilder, shouldBeLimited, enabled: isEnabled
          })

    return isEnabled && !isError ? data : undefined
  }

  const useHasCorrectWHStatusMetadata = ({ fields = undefined }) => (
    useMemo(() => fields?.filter(item => item.name === WAREHOUSE_STATUS && WAREHOUSE_HYBRID_VALUES.includes(item.defaultValue)).length > 0, [fields])
  )

  return {
    usePendingApprovalsCount,
    useHasCorrectWHStatusMetadata
  }
})()
